import { css } from 'styled-components';
export default function styledIf(condition) {
  const check = props => typeof condition === 'function' ? condition(props) : props[condition];
  return (strings, ...args) => props => check(props) && css(strings, ...args);
}